function SliderTestimony() {

    this.build();
    barbaCallbacks.push(this);

}

SliderTestimony.prototype.build = function(){

    $('.slider-testimony').each(function(){
        let slider = $(this);
        let nav = slider.next('.slider-testimony-nav');

        slider.slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1
        }).on('afterChange', function(event, slick, currentSlide, nextSlide){
            nav.find('li.active').removeClass('active');
            nav.find('li:eq('+currentSlide+')').addClass('active');
        });

        $('li span', nav).on('click', function(){
            slider.slick('slickGoTo', $(this).parent('li').index() );
        });

    });

};
